/**
 * 파일 패널 (P7-⑤) — 파일 선택 또는 URL 임베드.
 *  - "파일 선택" → onPickFile()(에디터의 이미지 피커/업로드 파이프라인).
 *  - URL 입력 → 확장자로 이미지/비디오 블록, 아니면 인라인 링크 문단 삽입.
 * 트리거: 슬래시 메뉴 항목. body 절대배치.
 */

/** URL 확장자 → 블록 (이미지/비디오가 아니면 인라인 링크 문단) */
export function blockFromUrl(url) {
  const clean = String(url || "").split("?")[0].split("#")[0];
  const ext = (clean.match(/\.([a-z0-9]+)$/i) || [])[1] || "";
  if (/^(png|jpe?g|gif|webp|bmp|avif)$/i.test(ext)) return { type: "image", props: { url, caption: "", previewWidth: 512 }, content: [], children: [] };
  if (/^(mp4|webm|ogg|mov|m4v)$/i.test(ext)) return { type: "video", props: { url }, content: [], children: [] };
  return { type: "paragraph", props: { textColor: "default", backgroundColor: "default", textAlignment: "left" }, content: [{ type: "link", href: url, content: [{ type: "text", text: url, styles: {} }] }], children: [] };
}

export function attachFilePanel(editorEl, opts) {
  opts = opts || {};
  const onPickFile = typeof opts.onPickFile === "function" ? opts.onPickFile : () => {};
  const onInsertBlock = typeof opts.onInsertBlock === "function" ? opts.onInsertBlock : () => {};

  const pop = document.createElement("div");
  pop.className = "lumir-file-panel";
  pop.style.position = "absolute";
  pop.style.display = "none";
  pop.innerHTML =
    `<button type="button" class="lfp-btn" data-act="file">파일 선택</button>` +
    `<div class="lfp-row"><input type="text" class="lfp-url" placeholder="이미지/영상/링크 URL…" /><button type="button" class="lfp-btn" data-act="embed">삽입</button></div>`;
  document.body.appendChild(pop);

  function closestEditable(node) {
    const el = node && node.nodeType === 1 ? node : node && node.parentElement;
    return el ? el.closest(".content, td.lumir-cell") : null;
  }
  function rectOf(x) { try { return x && x.getBoundingClientRect ? x.getBoundingClientRect() : null; } catch (_) { return null; } }
  function hide() { pop.style.display = "none"; }

  function open(anchor) {
    const sel = window.getSelection();
    let rect = null;
    if (sel && sel.rangeCount) {
      const r = sel.getRangeAt(0);
      const content = closestEditable(r.startContainer);
      if (content && editorEl.contains(content)) rect = rectOf(r);
    }
    // 캐럿 위치를 못 잡으면 기준 블록 → 에디터 순으로 폴백(좌상단(0,0) 방지)
    if (!rect || (!rect.bottom && !rect.left)) rect = rectOf(anchor) || rectOf(editorEl) || { bottom: 0, left: 0 };
    pop.style.top = window.scrollY + (rect.bottom || 0) + 6 + "px";
    pop.style.left = window.scrollX + (rect.left || 0) + "px";
    pop.style.display = "block";
    const input = pop.querySelector(".lfp-url");
    if (input) { input.value = ""; setTimeout(() => { try { input.focus(); } catch (_) {} }, 0); }
    return true;
  }

  function embed() {
    const input = pop.querySelector(".lfp-url");
    const url = input ? input.value.trim() : "";
    if (!url) return;
    onInsertBlock(blockFromUrl(url));
    hide();
  }

  pop.addEventListener("mousedown", (e) => { if (!e.target.closest("input")) e.preventDefault(); });
  pop.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-act]");
    if (!btn) return;
    if (btn.dataset.act === "file") { onPickFile(); hide(); }
    else if (btn.dataset.act === "embed") embed();
  });
  pop.addEventListener("keydown", (e) => {
    if (e.target.classList && e.target.classList.contains("lfp-url")) {
      if (e.key === "Enter") { e.preventDefault(); embed(); }
      else if (e.key === "Escape") { e.preventDefault(); hide(); }
    }
  });

  return {
    element: pop,
    open,
    hide,
    embed,
    isOpen: () => pop.style.display !== "none",
    destroy() { if (pop.parentNode) pop.parentNode.removeChild(pop); },
  };
}
